import React, { useState, useEffect ,useRef} from 'react'
import { Link } from 'react-router-dom'
import ReactPaginate from "react-paginate";
function UserDirectoryComp() {
    const [recentjoinylist, setRecentjoinylist] = useState([]);
    const [emplist, setEmplist] = useState([]);
    const [perPage, setPerpage] = useState('');
    const [totalitem, setTotalitem] = useState('');
    const [searchbytext, setSearchbytext] = useState('');
    const [deptid, setDeptid] = useState('');
    let SERVER_URL = process.env.REACT_APP_API_URL;
    let BASE_URL = process.env.REACT_APP_APP_URL;
    let token = JSON.parse(localStorage.getItem('key'));
    const pagination = useRef();
    const setPage = ({ selected }) => {
        getuserlist('', selected + 1, '');
      }
    useEffect(() => {
        getRecentJoin()
        getuserlist('', 1, deptid)
    }, [])

    const getRecentJoin = () => {
        const response = fetch(SERVER_URL + `api/employee/recently-joining`,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'authorization': `bearer ${token.value}`
                }
            }).then(res => res.json())
            .then(data => {
                setRecentjoinylist(data.result)
            });


    }
    const getuserlist = async (textsearch, pagenumber, dept_id) => {
        const response = await fetch(SERVER_URL + `api/employee?query=${textsearch}&page=${pagenumber == 'undefined' ? 1 : pagenumber}&department=${dept_id}`,
            {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'authorization': `bearer ${token.value}`
                },
            })
            .then(res => res.json())
            .then(data => {
                // console.log(data);
                setEmplist(data.users)
                setTotalitem(data.Emptotal[0].Total);
                setPerpage(data.limit)
            });
    }
    return (

        <div className="container-fluid">
            <div className="table_search_wrp float-end">
                <select className="form-select form-select1">
                    <option>Most Recent</option>
                    <option>A to Z</option>
                    <option>Department</option>
                    <option>Branch</option>
                </select>
                <div className="search_wrp">
                    <input type="text" className="form-control" placeholder="Search" />
                    <i className="icon icon-magnifier"></i>
                </div>
            </div>
            <div className="dash_ttl">
                Directory
            </div>
            <div className="crumbs">
                <ul id="breadcrumbs" className="breadcrumb">
                    <li>
                        <Link to="/dashboard">Dashboard </Link>
                    </li>
                    <li className="current">
                        <span>/</span>Directory
                    </li>
                </ul>
            </div>
            <div className="row">

                <div className="col-lg-12">
                    <div className="box_white mb20 minh-unset">
                        <div className="box_heading fs15">
                            Recent Joining
                        </div>
                        <div className="box_content">
                            <div className="row">
                                {
                                    recentjoinylist?.map((item, ind) => {

                                        var img_url = 'images/m_user.png';
                                        if (item.gender == 1) {
                                            var img_url = 'images/m_user.png'
                                        }
                                        if (item.gender == 2) {
                                            var img_url = 'images/f_user.png'
                                        }
                                        // if(item.user_image!='' || item.user_image!=null || item.user_image!=undefined){
                                        // 	var img_url = 'images/'+item.user_image;
                                        // }

                                        return <div key={ind} className="col-lg-3">
                                            <div className="directory_card_blk mb30">
                                                <div className="user_profile">
                                                    <img src={`assets/${img_url}`} alt="" />
                                                </div>
                                                <div className="username_blk">{item?.name ? item.name : ''}</div>
                                                <div className="employcode_blk"><b>Employee Code:</b> <span>{item?.user_code ? item.user_code : ''}</span></div>
                                                <div className="designation_blk">{item?.role_name ? item.role_name : ''}</div>
                                                <div className="department_blk"><b>Department:</b> <span>{item?.dept_name ? item.dept_name : ''}</span> </div>
                                                <hr className="line_1"></hr>
                                                <div className="phone_blk mb05">
                                                    <i className="icon icon-telephone mr03"></i> <span>+91 {item?.contact_no ? item.contact_no : 'N/A'}</span>
                                                </div>
                                                <div className="mail_blk">
                                                    <i className="icon icon-envelope mr03"></i> <span>{item?.email ? item.email : 'N/A'} </span>
                                                </div>
                                            </div>
                                        </div>

                                    })
                                }
                            </div>
                        </div>
                    </div>


                    <div className="box_white mb20 minh-unset">
                        <div className="box_heading fs15">
                            Directory
                        </div>
                        <div className="box_content">
                            <div className="row">
                                {
                                    emplist?.map((item, ind) => {
                                        return <div className="col-lg-3" key={ind}>
                                            <div className="directory_card_blk mb30">
                                                <div className="user_profile">
                                                    <img src="assets/images/m_user.png" alt="" />
                                                </div>
                                                <div className="username_blk">{item?.name ? item.name : ''}</div>
                                                <div className="employcode_blk"><b>Employee Code:</b> <span>{item?.user_code?item.user_code:''}</span></div>
                                                <div className="designation_blk">{item?.role_name?item.role_name:'N/A'}</div>
                                                <div className="department_blk"><b>Department:</b> <span>{item?.dept_name?item.dept_name:'N/A'}</span> </div>
                                                <hr className="line_1"></hr>
                                                <div className="phone_blk mb05">
                                                    <i className="icon icon-telephone mr03"></i> <span>+91+ {item?.contact_no?item.contact_no:'N/A'}</span>
                                                </div>
                                                <div className="mail_blk">
                                                    <i className="icon icon-envelope mr03"></i> <span>{item?.emai?item.emai:'N/A'}</span>
                                                </div>
                                            </div>
                                        </div>
                                    })
                                }

                <div colSpan="8" >
                  <span onClick={e => pagination.current.setState({ selected: 10 - 1 })} ></span>
                  <ReactPaginate
                    ref={pagination}
                    pageCount={Math.ceil(totalitem / perPage)}
                    pageRangeDisplayed={4}
                    marginPagesDisplayed={1}
                    onPageChange={setPage}
                    containerClassName="pagination"
                    activeClassName="active"
                    pageLinkClassName="page-link"
                    breakLinkClassName="page-link"
                    nextLinkClassName="page-link"
                    previousLinkClassName="page-link"
                    pageClassName="page-item"
                    breakClassName="page-item"
                    nextClassName="page-item"
                    previousClassName="page-item"
                    previousLabel={<>&laquo;</>}
                    nextLabel={<>&raquo;</>}
                  />
                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default UserDirectoryComp
